<template>
  <div>
    <div class="group">
      <label>Company</label>
      <AjaxSelect v-model="company" api="/api/entity/company/select" :map-fn="(i) => `${i.name} (${i.branchName})`"
        :query="{ branch: allowedBranchIds }" />
    </div>

    <div class="columns">

      <div class="column">
        <div class="group">
          <label>{{ $t('start') }}</label>
          <datetime v-model="start" type="datetime" value-zone="local" input-id="p_start" input-style="width: 100%"
            :max-datetime="end" />
        </div>
        <div class="group">
          <label>{{ $t('end') }}</label>
          <datetime v-model="end" type="datetime" value-zone="local" input-id="p_end" input-style="width: 100%"
            :min-datetime="start" />
        </div>
      </div>

      <div class="column">
        <div class="group">
          <label>{{ $t('search') }}</label>
          <input type="text" v-model="search">
        </div>
        <div class="group">
          <label>PER PAGE</label>
          <select v-model="perPage.selected">
            <option :value="pp" v-for="pp of perPage.all" :key="`pp_${pp}`">{{ pp }}</option>
          </select>
        </div>
      </div>

    </div>

    <div class="action-buttons">
      <div>
        <button class="btn btn-primary" @click="load">{{ $t('search') }}</button>
      </div>
      <div>
        <button class="btn btn-primary" :disabled="!hasPrevious" @click="previousPage">{{ $t('previous') }}</button>
        <button class="btn btn-primary" :disabled="!hasNext" @click="nextPage">{{ $t('next') }}</button>
      </div>
    </div>

    <table class="log-table">
      <thead>
        <tr>
          <th>AT</th>
          <th>FIELD</th>
          <th>OLD VALUE</th>
          <th>NEW VALUE</th>
          <th>BY</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="e of loaded.data" :key="`tr_${e.id}`">
          <td>{{ prettyDate(e.log.createdAt) }}</td>
          <td>{{ e.pa }}</td>
          <td>{{ e.ov }}</td>
          <td>{{ e.nv }}</td>
          <td>{{ e.log.user.username }} ({{ e.log.user.id }})</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import Datatable from "@/components/Datatable.vue";
  import AjaxSelect from "@/components/tools/AjaxSelect.vue";
  import { Core } from "@/core/Core";
  import { DateTime } from "luxon";

  export default {
    name: "CompanyChangeLog",
    components: { Datatable, AjaxSelect },

    data() {
      return {
        perPage: {
          selected: 20,
          all: [20, 50, 100, 200]
        },
        company: { id: null },
        start: null,
        end: null,
        search: null,
        loaded: {
          data: [],
          meta: {}
        }
      }
    },

    computed: {
      hasPrevious() {
        return (this.loaded.meta.currentPage || 1) > 1;
      },
      hasNext() {
        return this.loaded.data.length === (this.loaded.meta.itemsPerPage || this.loaded.meta.perPage);
      },
      currentPage() {
        return this.loaded.meta.currentPage || 1;
      },
      contextServer() {
        return this.$store.state.contextServer;
      },
      allowedBranchIds() {
        if (!this.$store.state.loggedUser.accessibleBranches) {
          return undefined;
        }
        return this.$store.state.loggedUser.accessibleBranches
          .filter(sb => sb.server.id === this.contextServer.id)
          .map(sb => sb.branchId);
      }
    },

    mounted() {
      this.$store.state.pageTitleTranslationKey = "Company change log";
      this.$store.state.pageIcon = "";
    },

    methods: {
      previousPage() {
        this.load(Math.max(this.currentPage - 1, 1))
      },
      nextPage() {
        this.load(this.currentPage + 1)
      },
      async load(page = 1) {
        let params = {
          page: page,
          perPage: this.perPage.selected,
          company: this.company.id,
          start: this.fixDate(this.start) || undefined,
          end: this.fixDate(this.end) || undefined,
          search: this.search || undefined
        }
        if (!params.company) {
          toast('Company parameter is required', 'error')
        }
        this.loaded = await Core.request('GET', '/api/company_change_logs_details', params);
      },
      fixDate(date) {
        return date ? date.replace('T', ' ').substring(0, 19) : null;
      },
      prettyDate(str) {
        if (!str) {
          return ''
        }
        let luxonDate = DateTime.fromFormat(str, 'yyyy-MM-dd HH:mm:ss');
        return luxonDate.invalid ? str : luxonDate.toLocaleString(DateTime.DATETIME_MED);
      },
    }
  }
</script>

<style lang="scss" scoped>
  .action-buttons {
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;

    button:not(:last-child) {
      margin-right: 10px;
    }
  }

  .log-table {
    width: 100%;

    td,
    th {
      padding: 4px 4px;
      text-align: left;
    }

    th {
      white-space: nowrap;
      background-color: #ddd;
    }

    tr:nth-child(odd) {
      background-color: #eee;
    }

    tr {
      page-break-inside: avoid;
    }
  }
</style>